var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _vm.step === 0
        ? _c(
            "el-form",
            {
              ref: "formRef",
              staticClass: "form-box",
              attrs: { model: _vm.form, "label-width": "150px" }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "个人姓名：",
                    prop: "realName",
                    rules: [
                      {
                        required: true,
                        message: "请输入个人姓名",
                        trigger: "blur"
                      }
                    ]
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.realName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "realName", $$v)
                      },
                      expression: "form.realName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "身份证号码：",
                    prop: "idcardNo",
                    rules: [
                      {
                        required: true,
                        message: "请输入身份证号码",
                        trigger: "blur"
                      }
                    ]
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.idcardNo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "idcardNo", $$v)
                      },
                      expression: "form.idcardNo"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "联系电话：",
                    prop: "phone",
                    rules: [
                      {
                        required: true,
                        message: "请输入联系电话",
                        trigger: "blur"
                      }
                    ]
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "phone", $$v)
                      },
                      expression: "form.phone"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "联系地址：",
                    prop: "address",
                    rules: [
                      {
                        required: true,
                        message: "请输入联系地址",
                        trigger: "blur"
                      }
                    ]
                  }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.address,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "address", $$v)
                      },
                      expression: "form.address"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.type === "food"
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "智恒小程序用户ID：",
                        prop: "address",
                        rules: [
                          {
                            required: true,
                            message: "请输入智恒小程序用户ID",
                            trigger: "blur"
                          }
                        ]
                      }
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.appletUserId,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "appletUserId", $$v)
                          },
                          expression: "form.appletUserId"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.nextStep } },
                    [_vm._v("下一步")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.step === 1
        ? _c("div", { staticClass: "protocol-box" }, [
            _vm.type === "food"
              ? _c("img", {
                  attrs: {
                    src:
                      "https://res.study.itaojin.cn/2024-12/a2db0178b91242aa95dccc40e7bea392.png",
                    alt: ""
                  }
                })
              : _c("img", {
                  attrs: {
                    src:
                      "https://res.study.itaojin.cn/2024-12/43abc179e17f495fbc5470878567ac8d.png",
                    alt: ""
                  }
                }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btns" },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        _vm.step = _vm.step - 1
                      }
                    }
                  },
                  [_vm._v("上一步")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", disabled: !!_vm.countdown },
                    on: { click: _vm.signContract }
                  },
                  [
                    _c("span", [_vm._v("去签名")]),
                    _vm._v(" "),
                    _vm.countdown
                      ? _c("span", [_vm._v("(" + _vm._s(_vm.countdown) + "s)")])
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ])
        : _vm.step === 2
        ? _c("div", { staticClass: "protocol-box" }, [
            _c("img", { attrs: { src: _vm.dealUrl, alt: "" } }),
            _vm._v(" "),
            _vm.$route.query.admin
              ? _c(
                  "div",
                  { staticClass: "btns" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            _vm.step = 0
                          }
                        }
                      },
                      [_vm._v("修 改")]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "请签名",
            visible: _vm.dialogObj.visible,
            width: "500px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.dialogObj, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "box" },
            [
              _c("vue-esign", {
                ref: "esign",
                attrs: {
                  width: 458,
                  height: 260,
                  isCrop: false,
                  lineWidth: 3,
                  lineColor: "#000"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.handleReset } }, [
                _vm._v("重 写")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.submitFun }
                },
                [_vm._v("提交签名")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14266934", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14266934","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/signContract.vue
// module id = 1103
// module chunks = 0